import { Injectable } from '@angular/core';
import { BaseChainBaseGuard } from '../../internal';

@Injectable({
  providedIn: 'root'
})
export class UserViewerGuard extends BaseChainBaseGuard {
  override async canActivate(): Promise<boolean> {

    const user = this.baseChainGuardFacade.snapshot_user();

    if (!user) {
      this.baseChainGuardFacade.requestMe();
    }

    return true;
  }
}
